export default __webpack_public_path__ + "static/media/bet9.9c2c47c0.png";